// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"e4128835","514":"f472575c"}[chunkId] + ".chunk.js";
};